import Form from './Form';
import Info from './Info';

const defaultComponents = { Form, Info };

export default defaultComponents;
